__turbopack_context__.v({
  "content_row_link_popover": "ContentRowLinkPopover-module-scss-module__l7CSna__content_row_link_popover",
});
